module.exports = __webpack_public_path__ + "assets/images/client-7.63dc435e.jpeg";